// this is an automatically generated file from the ßoilerplate framework

// /srv/codepad-project/@vue-modules/app/vue;
import app from '@/app.functions.js';


export default {app: app, };